module.exports = __webpack_public_path__ + "media/images/redesign-images/about-us/college-logos/univ-michigan-d5bfef33624d7e8a61bbcb463cf195e9.svg";